export default {
    checkInSaleEngineer: 'Check-In Sale Engineer',
    jobId: 'Job ID',
    address: 'Address',
    date: 'Date',
    customerName: 'Customer Name',
    customerPerson: 'Customer Person',
    customerPhone: 'Customer Phone',
    origin: 'Origin',
    startDate: 'Start Date',
    startTime: 'Start Time',
    startMilieage: 'Start Milieage',
    endDate: 'End Date',
    endTime: 'End Time',
    endMilieage: 'End Milieage',
    activities: 'Activities',
    cancel: 'Cancel',
    submit: 'Submit',
    edit: 'Edit',
    save: 'Save',
    searching: 'Searching for your location ...',
    fieldRequired: 'This field is required',
    msgNoInquiry: 'You have no onsite inquiry today',
    networkError: 'Network error, please contact support for further information',
    msgSuccess: 'Save success',
    msgGPSError: 'Please turn on GPS. To indicate your location',
    getLocationError: 'Get location error',
    cannotGetLineId: 'Cannot get line user id',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    warning: 'Warning',
    error: 'Error',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    msgRequiredEmail: 'E-mail is required',
    msgInvalidEmailFormat: 'Invalid e-mail format',
    msgExceededEmail: 'E-mail is exceeded 255 characters',
    msgIncorrectPhoneNumber: 'Incorrect Phone Number'
}
